import {useCallback, useMemo, useState} from 'react';
import JobService from '../../../../../../API/orders/job/JobService';
import DateTimeUtil from '../../../../../../utils/common/DateTimeUtil';

export const isTechnicalMapRowActionActive = (type, row, estimateIsCurrent) =>
    type === 'cancelExecute'
    || type === 'delete'
    || (type === 'edit' && !row.completed)
    || (type === 'execute' && !row.completed && estimateIsCurrent);

const useTechnicalMapRowActions = ({setData, estimateIsCurrent, handleModalAlert}) => {
    const profileRaw = localStorage.getItem('profile');
    const profile = profileRaw ? JSON.parse(profileRaw) : null;
    const isSettingsRole = !!profile?.userRoles?.find((el) => el.name === 'ROLE_ORGANIZATION_USER_SETTINGS');

    const [openModalSimilarWorker, setOpenModalSimilarWorker] = useState(false);
    const [openModalExecuteJob, setOpenModalExecuteJob] = useState(false);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [modalCancelExecuteJob, setModalCancelExecuteJob] = useState(false);
    const [currentIdRow, setCurrentIdRow] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);
    const [isDelete, setIsDelete] = useState(false);

    const isActionActive = useCallback(
        (type, row) => isTechnicalMapRowActionActive(type, row, estimateIsCurrent),
        [estimateIsCurrent],
    );

    const similarWorker = useCallback((row) => {
        setCurrentIdRow(row.id);
        setCurrentRow(row);
        setOpenModalSimilarWorker(true);
    }, []);

    const executeJob = useCallback((row) => {
        setCurrentIdRow(row.id);
        setCurrentRow(row);
        setOpenModalExecuteJob(true);
    }, []);

    const cancelExecuteJob = useCallback((row) => {
        setCurrentRow(row);
        setIsDelete(false);
        setModalCancelExecuteJob(true);
    }, []);

    const deleteJob = useCallback((row) => {
        setCurrentRow(row);
        setIsDelete(true);
        setModalCancelExecuteJob(true);
    }, []);

    const handleCloseCancelExecuteJob = useCallback(() => {
        setCurrentRow(null);
        setModalCancelExecuteJob(false);
    }, []);

    const handleSubmitCancelExecuteJob = useCallback(() => {
        if (isDelete) {
            JobService.delete(currentRow?.id)
                .then(() => {
                    setData((prev) => (Array.isArray(prev) ? prev : []).filter((el) => el.id !== currentRow?.id));
                    handleCloseCancelExecuteJob();
                    handleModalAlert('Удалено', 'success');
                })
                .catch((error) => {
                    handleModalAlert(error);
                });
            return;
        }

        JobService.closeExecuteJob(currentRow?.id)
            .then(() => {
                setData((prev) => (Array.isArray(prev) ? prev : []).map((el) => (el.id === currentRow?.id ? {
                    ...el,
                    completed: false,
                    completion: null,
                } : el)));
                handleCloseCancelExecuteJob();
                handleModalAlert('Выполнение отменено', 'success');
            })
            .catch((error) => {
                handleModalAlert(error);
            });
    }, [currentRow, handleCloseCancelExecuteJob, handleModalAlert, isDelete, setData]);

    const closeExecuteJob = useCallback(() => {
        setCurrentIdRow(null);
        setCurrentRow(null);
        setOpenModalExecuteJob(false);
    }, []);

    const closeSimilarWorker = useCallback(() => {
        setCurrentIdRow(null);
        setCurrentRow(null);
        setOpenModalSimilarWorker(false);
    }, []);

    const onExecute = useCallback(() => {
        JobService.executeJob(currentIdRow, DateTimeUtil.dateConvert(currentDate))
            .then(() => {
                setData((prev) => (Array.isArray(prev) ? prev : []).map((el) => (el.id === currentIdRow ? {
                    ...el,
                    completed: true,
                    completion: currentDate,
                } : el)));
                closeExecuteJob();
                handleModalAlert('Выполнено', 'success');
            })
            .catch((error) => {
                handleModalAlert(error);
            });
    }, [closeExecuteJob, currentDate, currentIdRow, handleModalAlert, setData]);

    const menuItems = useMemo(() => (isSettingsRole ? [
        {type: 'edit', text: 'Редактировать', handler: similarWorker},
        {type: 'execute', text: 'Выполнить работу', handler: executeJob},
        {type: 'cancelExecute', text: 'Отменить выполнение', handler: cancelExecuteJob},
        {type: 'delete', text: 'Удалить', handler: deleteJob},
    ] : [
        {type: 'edit', text: 'Редактировать', handler: similarWorker},
        {type: 'execute', text: 'Выполнить работу', handler: executeJob},
    ]), [cancelExecuteJob, deleteJob, executeJob, isSettingsRole, similarWorker]);

    return {
        isSettingsRole,
        menuItems,
        isActionActive,
        similarWorker,
        executeJob,
        cancelExecuteJob,
        deleteJob,
        openModalSimilarWorker,
        closeSimilarWorker,
        currentIdRow,
        openModalExecuteJob,
        closeExecuteJob,
        currentDate,
        setCurrentDate,
        onExecute,
        modalCancelExecuteJob,
        handleCloseCancelExecuteJob,
        handleSubmitCancelExecuteJob,
        isDelete,
    };
};

export default useTechnicalMapRowActions;
